<h2 class="text-center">Operations Dashboard</h2>
<div class="container mt-5 mis-dashboard">
  <!-- Filters -->
  <section>
    <div class="container-fluid">
<!--      <div class="d-flex gap-2">-->
<!--        <ng-container *ngIf="isSeniorTeacher; else teacherFilter">-->
<!--          <mat-form-field appearance="outline">-->
<!--            <mat-label>Centre</mat-label>-->
<!--            <mat-select [(ngModel)]="selectedCentre">-->
<!--              <mat-option *ngFor="let centre of (centres$ | async)" [value]="centre">{{centre.centreName}}</mat-option>-->
<!--            </mat-select>-->
<!--          </mat-form-field>-->
<!--          <mat-form-field appearance="outline">-->
<!--            <mat-label>Date Range</mat-label>-->
<!--            <mat-date-range-input [rangePicker]="picker">-->
<!--              <input matStartDate placeholder="Start date" [(ngModel)]="startDate">-->
<!--              <input matEndDate placeholder="End date" [(ngModel)]="endDate">-->
<!--            </mat-date-range-input>-->
<!--            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>-->
<!--            <mat-date-range-picker #picker></mat-date-range-picker>-->
<!--          </mat-form-field>-->
<!--        </ng-container>-->
<!--        <ng-template #teacherFilter>-->
<!--          <mat-form-field appearance="outline">-->
<!--            <mat-label>Centre</mat-label>-->
<!--            <mat-select [(ngModel)]="selectedCentre">-->
<!--              <mat-option *ngFor="let centre of (allowedCentres$ | async)" [value]="centre">{{centre.centreName}}</mat-option>-->
<!--            </mat-select>-->
<!--          </mat-form-field>-->
<!--          <mat-form-field appearance="outline">-->
<!--            <mat-label>Date Range</mat-label>-->
<!--            <mat-date-range-input [rangePicker]="picker">-->
<!--              <input matStartDate placeholder="Start date" [(ngModel)]="startDate">-->
<!--              <input matEndDate placeholder="End date" [(ngModel)]="endDate">-->
<!--            </mat-date-range-input>-->
<!--            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>-->
<!--            <mat-date-range-picker #picker></mat-date-range-picker>-->
<!--          </mat-form-field>-->
<!--        </ng-template>-->
<!--      </div>-->
      <!-- Cards Section -->
      <div class="row">
        <!-- Card 1 -->
        <div class="col-md-3">
          <div class="info-box7 l-bg-card1 order-info-box7 scale-on-hover">
            <div class="info-box7-block">
              <h4 class="m-b-20">No of Hospital</h4>
              <h2 class="text-end">
                <i class="fas fa-hospital float-start"></i>
                <span>{{ totalHospitalCount || 0 }}</span>
              </h2>
            </div>
          </div>
        </div>

        <!-- Card 2 -->
        <div class="col-md-3">
          <div class="info-box7 l-bg-card2 order-info-box7 scale-on-hover">
            <div class="info-box7-block">
              <h4 class="m-b-20">No. of Volunteer</h4>
              <h2 class="text-end">
                <i class="fas fa-user-friends float-start"></i>
                <span>{{ totalVolunteersCount || 0 }}</span>
              </h2>
            </div>
          </div>
        </div>

        <!-- Card 3 -->
        <div class="col-md-3">
          <div class="info-box7 l-bg-card3 order-info-box7 scale-on-hover">
            <div class="info-box7-block">
              <h4 class="m-b-20">Total Mealmate</h4>
              <h2 class="text-end">
                <i class="fas fa-utensils float-start"></i>
                <span>{{ totalMealmate || 0 }}</span>
              </h2>
            </div>
          </div>
        </div>

        <!-- Card 4 -->
        <div class="col-md-3">
          <div class="info-box7 l-bg-card4 order-info-box7 scale-on-hover">
            <div class="info-box7-block">
              <h4 class="m-b-20">Total Membership</h4>
              <h2 class="text-end">
                <i class="fas fa-handshake float-start"></i>
                <span>{{ totalMemberShip || 0 }}</span>
              </h2>
            </div>
          </div>
        </div>

        <!-- Card 5 -->
        <div class="col-md-3">
          <div class="info-box7 l-bg-card5 order-info-box7 scale-on-hover">
            <div class="info-box7-block">
              <h4 class="m-b-20">Total MSW</h4>
              <h2 class="text-end">
                <i class="fas fa-handshake float-start"></i>
                <span>{{ totalMswCount || 0 }}</span>
              </h2>
            </div>
          </div>
        </div>

        <!-- Card 6 -->
        <div class="col-md-3">
          <div class="info-box7 l-bg-card6 order-info-box7 scale-on-hover">
            <div class="info-box7-block">
              <h4 class="m-b-20">8080 Enquiry</h4>
              <h2 class="text-end">
                <i class="fas fa-question-circle float-start"></i>
                <span>{{ total8080Count }}</span>
              </h2>
            </div>
          </div>
        </div>

        <!-- Card 7 -->
        <div class="col-md-3">
          <div class="info-box7 l-bg-card7 order-info-box7 scale-on-hover">
            <div class="info-box7-block">
              <h4 class="m-b-20">Upcoming Events</h4>
              <h2 class="text-end">
                <i class="fas fa-bullhorn float-start"></i>
                <span>{{ upComingEvents || 0 }}</span>
              </h2>
            </div>
          </div>
        </div>

        <!-- Card 8 -->
        <div class="col-md-3">
          <div class="info-box7 l-bg-card8 order-info-box7 scale-on-hover">
            <div class="info-box7-block">
              <h4 class="m-b-20">In Stock Entry</h4>
              <h2 class="text-end">
                <i class="fas fa-boxes float-start"></i>
                <span>{{ total8080Count }}</span>
              </h2>
            </div>
          </div>
        </div>
      </div>
<div>
  <table mat-table [dataSource]="dataSource"  *ngIf="dataTableLoaded" matSort>

    <!-- Position Column -->
    <ng-container matColumnDef="centername"  >
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Centre Name</th>
      <td mat-cell *matCellDef="let element" class="scale-on-hover"  [ngClass]="element.isArchive?'archived':'normal'"
          [matTooltip]="element.centreCode"> {{element?.centreName}} </td>
      <td mat-footer-cell *matFooterCellDef  class="scale-on-hover"><strong> Total</strong> </td>

    </ng-container>

    <!-- Available Units  Column -->
    <ng-container matColumnDef="availableUnits">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Available </th>
      <td mat-cell *matCellDef="let element"  class="scale-on-hover"
          [ngClass]="element.isArchive?'archived':'normal'"> {{element?.availableUnits}}   </td>
      <td mat-footer-cell *matFooterCellDef  class="scale-on-hover"> <strong>{{lastRow?.availableUnits}}</strong> </td>

    </ng-container>
    <!-- Weight Column -->
    <ng-container matColumnDef="occupiedUnits">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Occupied </th>
      <td mat-cell *matCellDef="let element"  class="scale-on-hover"
          [ngClass]="element.isArchive?'archived':'normal'"> {{element?.occupiedUnits}} </td>
      <td mat-footer-cell *matFooterCellDef  class="scale-on-hover"><strong> {{lastRow?.occupiedUnits}}</strong> </td>

    </ng-container>
    <ng-container matColumnDef="sr">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Rank </th>
      <td mat-cell *matCellDef="let element;let i =index"  class="scale-on-hover"
          [ngClass]="element.isArchive?'archived':'normal'"> {{i+1}} </td>
      <td mat-footer-cell *matFooterCellDef  class="scale-on-hover"><strong> </strong> </td>

    </ng-container>
    <!-- Weight Column -->
    <ng-container matColumnDef="totalUnits" >
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Total Rooms</th>
      <td mat-cell *matCellDef="let element"  class="scale-on-hover"
          [ngClass]="element.isArchive?'archived':'normal'"> {{element?.totalUnits}} </td>
      <td mat-footer-cell *matFooterCellDef  class="scale-on-hover"><strong> {{lastRow?.totalUnits}}</strong> </td>

    </ng-container>
    <ng-container matColumnDef="centrePercentage" >
      <th mat-header-cell *matHeaderCellDef mat-sort-header > Occupancy %</th>
      <td mat-cell *matCellDef="let element"  class="scale-on-hover" > <span class="label" *ngIf="element" [ngClass]="{
    ' bg-green': element.centrePercentage === 100,
    ' label-warning': element.centrePercentage >= 90 && element.centrePercentage <= 99,
    ' label-yellow': element.centrePercentage >= 81 && element.centrePercentage <= 89,
    ' label-danger': element.centrePercentage <= 80 }" > {{element?.centrePercentage}}%</span>   </td>
      <td mat-footer-cell *matFooterCellDef><span *ngIf="lastRow" class="label label-info"> {{getPercentage(lastRow!)}}%</span> </td>

    </ng-container>
    <ng-container matColumnDef="occupancyPercentage">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Efficiency (24-25) </th>
      <td mat-cell *matCellDef="let element"  class="scale-on-hover " > <span class="label" *ngIf="element" [ngClass]="{
    ' bg-green': element.totalRanking >= 100,
    ' label-warning': element.totalRanking >= 91 && element.totalRanking <= 99,
    ' label-yellow': element.totalRanking >= 81 && element.totalRanking <= 90,
    ' label-danger': element.totalRanking <= 80 }"> {{element?.totalRanking}}%</span></td>
      <td mat-footer-cell *matFooterCellDef  class="scale-on-hover"><strong> </strong> </td>

    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>

    <!-- Row shown when there is no matching data. -->
    <tr *matNoDataRow class="mat-row">
      <!--                <td class="mat-cell" colspan="4"  >No data matching the filter "{{input.value}}"</td>-->
    </tr>
  </table>
</div>
    </div>
  </section>
</div>
